import apiClient from "@/api/client";
import type { EditorAvailability, EditorDocKind, EditorDocumentStatus, EditorSession } from "./types";

async function unwrap<T>(p: Promise<{ data: { data: T } }>): Promise<T> {
  return (await p).data.data;
}

/** Czy edytor w przeglądarce jest skonfigurowany (COLLABORA_PUBLIC_URL). */
export const getEditorAvailability = () =>
  unwrap<EditorAvailability>(apiClient.get("/office-editor/availability/"));

/** Otwórz sesję: token + adres edytora dla slotu (kind, id). 503 = edytor wyłączony,
 *  409 = plik nieedytowalny (PDF) / wniosek zamknięty, 403 = brak uprawnień. */
export const openEditorSession = (kind: EditorDocKind, id: string, opts?: { readOnly?: boolean }) =>
  unwrap<EditorSession>(apiClient.post("/office-editor/sessions/", {
    kind, id,
    // mode=view — podgląd bez prawa zapisu nawet dla uprawnionych (backend tylko zawęża).
    ...(opts?.readOnly ? { mode: "view" } : {}),
  }));

/** Stan slotu po zapisie: najnowsza wersja, pola ręczne, niepodstawione znaczniki. */
export const getEditorDocument = (kind: EditorDocKind, id: string) =>
  unwrap<EditorDocumentStatus>(apiClient.get(`/office-editor/documents/${kind}/${id}/`));

/** Powód z koperty błędu API albo tekst zastępczy. */
export function editorApiError(e: unknown, fallback = "Nie udało się otworzyć edytora."): string {
  const detail = (e as { response?: { data?: { errors?: { detail?: unknown } } } })
    ?.response?.data?.errors?.detail;
  return typeof detail === "string" && detail ? detail : fallback;
}
